<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('member.form.relation.title') }}</span>
          
          <div class="float-right"  v-if="compMode != CRUDMODE.READ">
            <a href="#action" name="action" @click="addRelation"><span class="fa fa-plus fa-lg"></span></a>
          </div>
        </div>
        <div class="card-body">
          <div class="row">

            <table id="dataTableAction" width="100%" cellspacing="0" 
                class="table table-bordered table-striped dataTable" >
             <thead>
                <tr>
                  <th width="150">{{ $t('member.form.relation.type') }}</th>
                  <th>{{ $t('member.form.relation.member') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th width="150">{{ $t('member.form.relation.type') }}</th>
                  <th>{{ $t('member.form.relation.member') }}</th>
                  <th width="50" v-if="compMode != CRUDMODE.READ"></th>
                </tr>
              </tfoot>
              <tbody>
                
                <tr class="odd" v-if="relations == undefined || relations.length == 0">
                    <td valign="top" colspan="6" class="dataTables_empty">Aucune donnée disponible dans le tableau</td>
                </tr>

                <tr v-if="relations != undefined" v-for="(item, index) in relations" v-bind:data-id="item.id" :key="item.id">
                  <td>
                    <select v-model="item.type" :data-vv-name="'type' + index"
                        v-validate="'required'" class="form-control" id="typeInput" :placeholder="$t('member.form.relation.type')">
                        <option v-for="s in relationTypes" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                    </select>
                    <span class="text-danger" v-if="errors.has('type'+ index)">{{ $t('validations.required') }}</span>
                  </td>
                  <td>
                      <multiselect
                            id="isMemberId"
                            v-model="item.isMemberId"
                            :options="memberOptions" 
                            :multiple="false" 
                            :taggable="false" 
                            :customLabel="memberSelectLabel"
                            v-bind:tag-placeholder="$t('multiselect.tag-placeholder')" 
                            v-bind:select-label="$t('multiselect.select-label')"
                            placeholder="" 
                            v-bind:deselect-label="$t('multiselect.deselect-label')"
                            v-bind:selectedLabel="$t('multiselect.selectedLabel')"
                            @select="f=> selectMember(f, item)">
                            <span slot="noResult">{{ $t('multiselect.not-found') }}.</span>
                        </multiselect>
                  </td>
                  <td align="center" v-if="compMode != CRUDMODE.READ">
                    <a  class="text-danger" v-bind:title="$t('form.delete_button')" href="#entrepreneur" v-on:click="removeRelation(index)">
                        <span class="fa fa-lg fa-trash"></span>
                    </a>
                  </td> 
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {MemberServiceClient, MemberRelationDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import Multiselect from 'vue-multiselect'
  import MomentDatePicker from '../../shared/components/MomentDatePicker'

  export default {
    name: 'CreateMemberRelation',
    inject: ['$validator'],
    props: {
      relations: {},
      members: {},
      id: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        relationTypes: [],
      }
    },
    computed: {
      memberOptions: function() {
        let usedMembers = _.keyBy(this.relations, function(o) {
          return o.isMemberId
        })
        let filteredMember = _.filter(this.members, x => {
          return x.id != this.id && usedMembers[x.id] === undefined
        })
        return _.map(filteredMember, 'id')
      },
    },
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    methods: {
      fetchData: function() {
        let memberService = ServiceFactory.create(MemberServiceClient)
        let getRelationTypes = memberService.getRelationTypes()
        let self = this
        getRelationTypes
          .then(res => {
            self.relationTypes = res
          })
          .catch(err => {
            err
          })
      },
      addRelation: function() {
        let dto = new MemberRelationDto()
        dto.init({})
        this.relations.push(dto)
      },
      removeRelation: function(index) {
        this.relations.splice(index, 1)
      },
      memberSelectLabel: function(option) {
        let member = _.find(this.members, x => x.id == option)

        if (member) {
          return member.id + ' - ' + member.name + ' ' + member.familyName
        }

        return ''
      },
      selectMember: function(f, item) {
        if (f != undefined) {
          let member = _.find(this.members, x => x.id == f)
          item.name = member.name
          item.familyName = member.familyName
        }
      },
    },
    components: {
      multiselect: Multiselect,
      'moment-date-picker': MomentDatePicker,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/members/CreateMemberRelation.vue